import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "television-option-card__title",
  "data-eq-part": "television-option-card__title"
}
const _hoisted_2 = { class: "television-option-card__title-name" }
const _hoisted_3 = {
  class: "television-option-card__benefits",
  "data-eq-part": "television-option-card__benefits"
}
const _hoisted_4 = {
  class: "television-option-card__price",
  "data-eq-part": "television-option-card__price"
}

import List from '@/components/List.vue';
import { formatNumber } from '@/helpers';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TelevisionOptionCard',
  props: {
    option: {},
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const monthlyBasePrice = computed(() => formatNumber(props.option.price?.recurring.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0, 2));

const optionProConList = computed(() => [
  ...(props.option.benefits || []),
  ...((props.option.cons || []).map((con: string | string[]) => [
    Array.isArray(con) ? con[0] : con,
    Array.isArray(con) ? con[1] : undefined,
    'fa-solid fa-xmark',
  ])),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["television-option-card io-eq-el", {
        small: _ctx.small,
      }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.option.name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(List, {
        type: "icon",
        icon: "fa-solid fa-check",
        items: optionProConList.value,
        small: _ctx.small
      }, null, 8, ["items", "small"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, "+" + _toDisplayString(monthlyBasePrice.value) + " €/Monat", 1)
    ])
  ], 2))
}
}

})